<template>
    <v-app>
        <router-view/>
    </v-app>
</template>

<script>

    export default {
        name: 'App',

        data: () => ({
            products: [],
            headers: [
                {text: 'Calories', value: 'calories'},
                {text: 'Fat (g)', value: 'fat'},
                {text: 'Carbs (g)', value: 'carbs'},
                {text: 'Protein (g)', value: 'protein'},
                {text: 'Iron (%)', value: 'iron'}
            ]
        })
    };
</script>
